
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="基本用法" fileName="base.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        fixed-header
        :scroll-width=&quot;1600&quot;
        :max-height=&quot;500&quot;
        border-y
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData&quot;
        rowKeyFieldName=&quot;rowKey&quot;
        :virtual-scroll-option=&quot;virtualScrollOption&quot;
        :cell-autofill-option=&quot;cellAutofillOption&quot;
        :rowStyleOption=&quot;rowStyleOption&quot;
    /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                },
                cellAutofillOption: {
                    directionX: true,
                    directionY: true,
                    beforeAutofill: ({
                        direction,
                        sourceSelectionRangeIndexes,
                        targetSelectionRangeIndexes,
                        sourceSelectionData,
                        targetSelectionData,
                    }) =&gt; {
                        console.log(&quot;direction::&quot;, direction);
                        console.log(&quot;sourceSelectionRangeIndexes::&quot;, sourceSelectionRangeIndexes);
                        console.log(&quot;targetSelectionRangeIndexes::&quot;, targetSelectionRangeIndexes);
                        console.log(&quot;sourceSelectionData::&quot;, sourceSelectionData);
                        console.log(&quot;targetSelectionData::&quot;, targetSelectionData);
                        console.log(&quot;---&quot;);
                    },
                    afterAutofill: ({
                        direction,
                        sourceSelectionRangeIndexes,
                        targetSelectionRangeIndexes,
                        sourceSelectionData,
                        targetSelectionData,
                    }) =&gt; {
                        console.log(&quot;direction::&quot;, direction);
                        console.log(&quot;sourceSelectionRangeIndexes::&quot;, sourceSelectionRangeIndexes);
                        console.log(&quot;targetSelectionRangeIndexes::&quot;, targetSelectionRangeIndexes);
                        console.log(&quot;sourceSelectionData::&quot;, sourceSelectionData);
                        console.log(&quot;targetSelectionData::&quot;, targetSelectionData);
                        console.log(&quot;---&quot;);
                    },
                },
                columns: [
                    {
                        field: &quot;index&quot;,
                        key: &quot;index&quot;,
                        // is operation column
                        operationColumn: true,
                        title: &quot;#&quot;,
                        width: 15,
                        fixed: &quot;left&quot;,
                    },
                    {
                        field: &quot;col1&quot;,
                        key: &quot;a&quot;,
                        title: &quot;col1&quot;,
                        width: 50,
                        fixed: &quot;left&quot;,
                    },
                    {
                        title: &quot;col2-col3&quot;,
                        fixed: &quot;left&quot;,
                        children: [
                            {
                                field: &quot;col2&quot;,
                                key: &quot;b&quot;,
                                title: &quot;col2&quot;,
                                width: 50,
                            },
                            {
                                field: &quot;col3&quot;,
                                key: &quot;col3&quot;,
                                title: &quot;col3&quot;,
                                width: 30,
                            },
                        ],
                    },
                    {
                        title: &quot;col4-col5-col6&quot;,
                        children: [
                            {
                                title: &quot;col4-col5&quot;,
                                children: [
                                    {
                                        field: &quot;col4&quot;,
                                        key: &quot;col4&quot;,
                                        title: &quot;col4&quot;,
                                        width: 110,
                                    },
                                    {
                                        field: &quot;col5&quot;,
                                        key: &quot;col5&quot;,
                                        title: &quot;col5&quot;,
                                        width: 120,
                                    },
                                ],
                            },
                            {
                                title: &quot;col6&quot;,
                                field: &quot;col6&quot;,
                                key: &quot;col6&quot;,
                                width: 130,
                            },
                        ],
                    },
                    {
                        title: &quot;col7&quot;,
                        fixed: &quot;right&quot;,
                        children: [
                            {
                                title: &quot;col7-1&quot;,
                                field: &quot;col7&quot;,
                                key: &quot;col7&quot;,
                                width: 50,
                            },
                        ],
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 100; i++) {
                    data.push({
                        rowKey: i,
                        index: i + 1,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"fixed-header":"","scroll-width":1600,"max-height":500,"border-y":"","columns":_vm.columns,"table-data":_vm.tableData,"rowKeyFieldName":"rowKey","virtual-scroll-option":_vm.virtualScrollOption,"cell-autofill-option":_vm.cellAutofillOption,"rowStyleOption":_vm.rowStyleOption}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                },
                cellAutofillOption: {
                    directionX: true,
                    directionY: true,
                    beforeAutofill: ({
                        direction,
                        sourceSelectionRangeIndexes,
                        targetSelectionRangeIndexes,
                        sourceSelectionData,
                        targetSelectionData,
                    }) => {
                        console.log("direction::", direction);
                        console.log("sourceSelectionRangeIndexes::", sourceSelectionRangeIndexes);
                        console.log("targetSelectionRangeIndexes::", targetSelectionRangeIndexes);
                        console.log("sourceSelectionData::", sourceSelectionData);
                        console.log("targetSelectionData::", targetSelectionData);
                        console.log("---");
                    },
                    afterAutofill: ({
                        direction,
                        sourceSelectionRangeIndexes,
                        targetSelectionRangeIndexes,
                        sourceSelectionData,
                        targetSelectionData,
                    }) => {
                        console.log("direction::", direction);
                        console.log("sourceSelectionRangeIndexes::", sourceSelectionRangeIndexes);
                        console.log("targetSelectionRangeIndexes::", targetSelectionRangeIndexes);
                        console.log("sourceSelectionData::", sourceSelectionData);
                        console.log("targetSelectionData::", targetSelectionData);
                        console.log("---");
                    },
                },
                columns: [
                    {
                        field: "index",
                        key: "index",
                        // is operation column
                        operationColumn: true,
                        title: "#",
                        width: 15,
                        fixed: "left",
                    },
                    {
                        field: "col1",
                        key: "a",
                        title: "col1",
                        width: 50,
                        fixed: "left",
                    },
                    {
                        title: "col2-col3",
                        fixed: "left",
                        children: [
                            {
                                field: "col2",
                                key: "b",
                                title: "col2",
                                width: 50,
                            },
                            {
                                field: "col3",
                                key: "col3",
                                title: "col3",
                                width: 30,
                            },
                        ],
                    },
                    {
                        title: "col4-col5-col6",
                        children: [
                            {
                                title: "col4-col5",
                                children: [
                                    {
                                        field: "col4",
                                        key: "col4",
                                        title: "col4",
                                        width: 110,
                                    },
                                    {
                                        field: "col5",
                                        key: "col5",
                                        title: "col5",
                                        width: 120,
                                    },
                                ],
                            },
                            {
                                title: "col6",
                                field: "col6",
                                key: "col6",
                                width: 130,
                            },
                        ],
                    },
                    {
                        title: "col7",
                        fixed: "right",
                        children: [
                            {
                                title: "col7-1",
                                field: "col7",
                                key: "col7",
                                width: 50,
                            },
                        ],
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 100; i++) {
                    data.push({
                        rowKey: i,
                        index: i + 1,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  